// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"1c89d75f","639":"d3a624a4"}[chunkId] + ".chunk.js";
};